import {PaymentCurrencyType} from "@irati/types"
import {Deal} from "@irati/types/ops"

export default function isRewards(deal: Deal) {
  return deal?.productConfig?.products[0]?.salePrice?.currency === PaymentCurrencyType.Rp
}
